import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  wrapper: {
    ...theme.mixins.appContainer,
    marginTop: theme.spacing(1),
  },
  content: {
    '& > div + div': {
      marginTop: theme.spacing(2),
    },
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      '& button': {
        width: '100%',
      },
    },
  },
  viewItem: {
    boxShadow: 'none',
    padding: `${theme.spacing(0.5)} 0 !important`,
  },
}));
